import React, { useEffect, useState } from "react";
import { ThumbsUp, Heart, Star, PartyPopper } from "lucide-react";
import { FaThumbsUp, FaHeart, FaStar, FaRegLaughBeam } from "react-icons/fa";
import { ADMIN_ID } from "./Constant";
import "./Blog.css";

const defaultReactions = {
  like: 0,
  love: 0,
  wow: 0,
  celebrate: 0,
};

const lucideIconMap = {
  like: ThumbsUp,
  love: Heart,
  wow: Star,
  celebrate: PartyPopper,
};

const faIconMap = {
  like: FaThumbsUp,
  love: FaHeart,
  wow: FaStar,
  celebrate: FaRegLaughBeam,
};

const colorMap = {
  like: "#3b82f6", // blue
  love: "#ef4444", // red
  wow: "#facc15",  // yellow
  celebrate: "#10b981", // green
};

const ReactionBar = ({ blogId }) => {
  const [reactions, setReactions] = useState(defaultReactions);
  const [selected, setSelected] = useState(null);
  const url=process.env.REACT_APP_LINK

  useEffect(() => {
    const fetchReactions = async () => {
      try {
        const res = await fetch(`${url}/api/reactions/slug/${blogId}`);
        const data = await res.json();
        setReactions((prev) => ({ ...prev, ...data }));
      } catch (err) {
        console.error("❌ Failed to fetch reactions:", err);
      }
    };

    if (blogId) fetchReactions();
  }, [blogId]);

  const handleReaction = async (type) => {
    setReactions((prev) => {
      const updated = { ...prev };
      if (selected && selected !== type) {
        updated[selected] = Math.max(0, updated[selected] - 1);
      }
      updated[type] = (updated[type] || 0) + 1;
      return updated;
    });

    setSelected(type);

    try {
      await fetch(`${url}/api/reactions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ slug: blogId, type, AdminId: ADMIN_ID }),
      });
    } catch (err) {
      console.error("❌ Failed to store reaction:", err);
    }
  };

  return (
    <div className="reaction-bar-premium">
      {Object.keys(lucideIconMap).map((type) => {
        const LucideIcon = lucideIconMap[type];
        const FaIcon = faIconMap[type];
        const isSelected = selected === type;

        return (
          <button
            key={type}
            onClick={() => handleReaction(type)}
            className={`reaction-btn ${isSelected ? "active" : ""}`}
            style={{
              borderColor: colorMap[type],
              backgroundColor: isSelected ? `${colorMap[type]}22` : "transparent",
            }}
          >
            <div className="icon-wrapper" style={{ color: isSelected ? colorMap[type] : "#999" }}>
              {isSelected ? <FaIcon size={20} /> : <LucideIcon size={20} />}
            </div>
            <span className="reaction-count">{reactions[type]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ReactionBar;
